<template>
  <!-- jls控制面板 组件 -->
  <div>
    <div class="normalContent" v-if="normalPan" :class="{ isOfflineMapClass: isOfflineMap }">
      <div :class="[hasWarn ? 'titleblock_warn' : 'titleblock']">
        <div>{{ inforUserName }}-{{ deviceName }}</div>
        <i
          :class="[isDefaultTheme ? 'warn_icon' : 'warn_icon_m']"
          @click="triggerwarn"
          v-if="hasWarn"
          title="切换告警数据"
        ></i>
        <i
          :class="[
            hasWarn
              ? isDefaultTheme
                ? 'fresh_icon_warn'
                : 'fresh_icon_warn_m'
              : isDefaultTheme
              ? 'fresh_icon'
              : 'fresh_icon_m',
          ]"
          title="刷新数据"
          @click="refreshInfoWindow"
        ></i>
        <!-- 离线地图时 关闭按钮添加 v-if="isOfflineMap"-->
      </div>
      <div class="inforMain">
        <div v-if="positionName" class="gpsInfo">
          <span>{{ $t('positionB') }}：</span>
          <span>{{ positionName }}</span>
          <!-- <div class="trailBtn" @click="changeJlsTrailVisible">
            <span>{{ $t('historicalTrack') }}</span>
            <i :class="[isDefaultTheme ? 'trail_icon' : 'trail_icon_m']"></i>
          </div> -->
        </div>
        <div class="deviceInfo">
          <div class="func_block">
            <div class="iconBlock" :class="[isDefaultTheme ? 'icon1' : 'icon1_m']"></div>
            <div class="iconInfo">
              <span class="description"
                >{{ $t('heartRate') }}：
                <span class="description_value">
                  {{ helmetInfo.heartRate ? helmetInfo.heartRate + $t('heartRateUnit') : '-' }}</span
                >
              </span>
              <div id="heartChart" :style="{ width: '190px', height: '123px' }"></div>
              <span class="heart-data heart-time">{{ helmetInfo.currenTime }}</span>
            </div>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="func_block">
            <div class="iconBlock" :class="[isDefaultTheme ? 'icon2' : 'icon2_m']"></div>
            <div class="iconInfo">
              <span class="description"
                >{{ $t('BloodOxygen') }}：<span class="description_value">{{
                  helmetInfo.bloodOxygen ? Number(helmetInfo.bloodOxygen).toFixed(1) + '%' : '-'
                }}</span></span
              >
              <div id="tempChart" :style="{ width: '190px', height: '123px' }"></div>
              <span class="heart-data temp-time">{{ helmetInfo.tempCurrenTime }}</span>
            </div>
          </div>
        </div>
        <div class="deviceInfo border_top">
          <div class="func_block">
            <div class="iconBlock" :class="[isDefaultTheme ? 'icon4' : 'icon4_m']"></div>
            <div class="iconInfo">
              <span class="description">{{ $t('signalIntensity') }}</span>
              <span class="description_value">{{
                helmetInfo.signNum ? helmetInfo.signLever + ':' + helmetInfo.signNum : '-'
              }}</span>
            </div>
          </div>
          <div class="func_block">
            <div class="iconBlock" :class="[isDefaultTheme ? 'icon5' : 'icon5_m']"></div>
            <div class="iconInfo">
              <span class="description">{{ $t('Power') }}</span>
              <span class="description_value">{{
                helmetInfo.freeBattery ? Number(helmetInfo.freeBattery).toFixed(1) + '%' : '-'
              }}</span>
            </div>
          </div>
          <div class="func_block">
            <div class="iconBlock" :class="[isDefaultTheme ? 'icon6' : 'icon6_m']"></div>
            <div class="iconInfo">
              <span class="description">{{ $t('pressure') }}</span>
              <span class="description_value">{{
                helmetInfo.altitude ? Number(helmetInfo.altitude).toFixed(3) + 'kPa' : '-'
              }}</span>
            </div>
          </div>
        </div>
        <div class="deviceIcon">
          <div class="status_block">
            <div
              :class="[
                onlineStatus === '1' ? (standbyStatus === 1 ? 'status_icon1' : 'status_icon1_on') : 'status_icon1',
              ]"
            ></div>
            <div class="status_des">{{ $t('sleepState') }}</div>
          </div>
          <div class="status_block">
            <div
              :class="[
                onlineStatus === '1' ? (wearingStatus === 1 ? 'status_icon2_on' : 'status_icon2') : 'status_icon2',
              ]"
            ></div>
            <div class="status_des">{{ $t('wearingHatState') }}</div>
          </div>
          <div class="status_block">
            <div
              :class="[
                onlineStatus === '1' ? (chargingStatus === 1 ? 'status_icon3' : 'status_icon3_on') : 'status_icon3',
              ]"
            ></div>
            <div class="status_des">{{ $t('chargingState') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="warnContent common-blue-contain" v-if="!normalPan" :class="{ isOfflineMapWarnClass: isOfflineMap }">
      <div class="titleblock_warn">
        <div class="title">{{ $t('alarmLog') }}</div>
        <i :class="[isDefaultTheme ? 'warn_icon' : 'warn_icon_m']" @click="triggerwarn"></i>
      </div>
      <el-table :data="tableData" style="width: 100%; border: 1px solid #ccc; padding: 10px" max-height="340">
        <el-table-column prop="alertType" :label="$t('alarmType')" :formatter="fileData"> </el-table-column>
        <el-table-column prop="createdTime" :label="$t('time')"> </el-table-column>
        <el-table-column :label="$t('operationh')" prop="status" width="100px">
          <template slot-scope="scope">
            <i
              :class="[scope.row.status ? 'DealClass' : 'unDealClass']"
              @click="dealClick(scope.row)"
              v-has="'alert:edit'"
            ></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { findMsgByDeviceName, updateStatus, selectRecord, gpsRecord, findAlertType } from '@/api/monitor'
import { nowDate, nextDate } from '@/api/common'
import { HeartChartOption, TempChartOption } from '@/assets/echartOption'
import { getLocation } from '@/common/map'
import { mapGetters } from 'vuex'
export default {
  props: {
    helmetdata: {
      type: Array / Object,
    },
  },
  data() {
    return {
      JlsTrailVisible: false,
      chargingStatus: '',
      standbyStatus: '',
      hasWarn: false,
      normalPan: true,
      inforUserName: '',
      deviceName: '',
      positionName: '',
      alertTypeList: [],
      tableData: [],
      // 安全帽在线状态
      onlineStatus: '0',

      wearingStatus: '',
      // 离线地图
      isOfflineMap: false,
      helmetInfo: {
        bodyTemperature: '',
        bloodOxygen: '',
        heartRate: '',
        signLever: '',
        signNum: '',
        freeBattery: '',
        altitude: '',
        currenTime: '',
        tempCurrenTime: '',
      },
      jlsHelmet: {},
    }
  },
  watch: {
    helmetdata: {
      immediate: true,
      handler(val) {
        this.searchPollInfo(val.specType, val)
        this.jlsHelmet = val
      },
    },
  },
  methods: {
    // 处理告警信息事件
    dealClick(row) {
      if (row.status === 0) {
        let param = [row.id]
        this.$confirm(this.$t('confirmtofinish'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        }).then(() => {
          updateStatus(param).then(res => {
            row.status = 1
          })
        })
        // 解决闪烁问题
        // this.$refs.infoWindow.observer.disconnect()
      }
    },
    // 获取心率体征等信息
    searchPollInfo(specType, item) {
      if (item) {
        this.deviceName = item.deviceName
        this.onlineStatus = item.onlineStatus
      }
      let param = {
        deviceName: this.deviceName,
        startTime: nowDate(),
        endTime: nextDate(),
        limit: 1,
        healthLimit: 1000,
      }
      // debug窗口显示问题
      setTimeout(() => {
        // this.infoWindow.show = true
        // this.infoWindow.jlsShow = true
        // this.infoWindow.gkShow = true
      }, 1)
      if (specType === 0) {
        this._selectRecord(param)
        clearInterval(this.selectRecordInterval)
        // 5秒循环请求一次
        // this.selectRecordInterval = setInterval(() => {
        //   this._selectRecord(param)
        // }, 10000)
        // GK3安全帽位置信息
        this._findAlertType()
        this._findMsgByDeviceName()
      } else {
        gpsRecord(param.deviceName).then(res => {
          let that = this
          if (res.data) {
            that.inforUserName = res.data[0].userName
            that.deviceTime = res.data[0].timestamp
            try {
              // 根据坐标得到地址描述
              let lng = res.data[0].position.lng
              let lat = res.data[0].position.lat
              getLocation(lng, lat, this.setDevicePosition)
              this.isOfflineMap = false
            } catch{
              that.positionName = '金星大厦'
              this.isOfflineMap = true
            }
          }
        })
      }
    },
    // 获取地址后的回调
    setDevicePosition(address) {
      this.positionName = address
    },
    // 获取控制面板数据
    async _selectRecord(param) {
      selectRecord(param).then(res => {
        let that = this
        // 弹窗面板开关
        if (res.state === 0) {
          this.inforUserName = res.data.userName
          let baseStationPage = res.data.baseStationPage
          let deviceStatusPage = res.data.deviceStatusPage
          let healthStatusPage = res.data.healthStatusPage
          let locationPage = res.data.locationPage
          if (baseStationPage) {
            this.IsBaseStationPage(baseStationPage)
          }
          if (deviceStatusPage) {
            this.IsDeviceStatusPage(deviceStatusPage)
          }
          if (healthStatusPage) {
            this.IshealthStatusPage(healthStatusPage)
          } else {
            this.drawHeartChart()
            this.drawTempChart()
          }
          if (locationPage) {
            if (!locationPage[0]) {
              this.positionName = '-'
              this.helmetInfo, (altitude = 12)
            } else {
              this.getAddress(locationPage[0].position)
              this.helmetInfo.altitude = locationPage[0].pressure / 1000
            }
          }
        }
      })
    },
    // 获取地址
    async getAddress(position) {
      this.positionName = await this.getPosition(position)
    },
    // 获取地址
    getPosition(position) {
      return new Promise((resolve, reject) => {
        getLocation(position.lng, position.lat, function(address) {
          if (address) {
            resolve(address)
          }
        })
      })
    },
    // 基站
    IsBaseStationPage(baseStationPage) {
      if (baseStationPage.length > 0) {
        this.helmetInfo.signNum = baseStationPage[0].rss
        if (this.helmetInfo.signNum > -75) {
          this.helmetInfo.signLever = this.$t('strong')
        } else if (this.helmetInfo.signNum < -85) {
          this.helmetInfo.signLever = this.$t('weak')
        } else {
          this.helmetInfo.signLever = this.$t('centre')
        }
      }
    },
    // 穿戴状态
    IsDeviceStatusPage(deviceStatusPage) {
      if (deviceStatusPage.length > 0) {
        this.chargingStatus = deviceStatusPage[0].chargingStatus
        this.wearingStatus = deviceStatusPage[0].wearingStatus
        this.standbyStatus = deviceStatusPage[0].standbyStatus
        this.helmetInfo.freeBattery = deviceStatusPage[0].freeBattery
      }
    },
    // 心率体征
    IshealthStatusPage(healthStatusPage) {
      if (healthStatusPage.recordList && healthStatusPage.recordList.length > 0) {
        this.bloodOxygen = healthStatusPage.recordList[0].bloodOxygen
        this.bodyTemperature = healthStatusPage.recordList[0].bodyTemperature
        this.heartRate = healthStatusPage.recordList[0].heartRate

        this.helmetInfo.heartRate = healthStatusPage.recordList[0].heartRate
        this.helmetInfo.bloodOxygen = healthStatusPage.recordList[0].bloodOxygen
        this.helmetInfo.bodyTemperature = healthStatusPage.recordList[0].bodyTemperature
        this.drawHeartChart(healthStatusPage.recordList)
        this.drawTempChart(healthStatusPage.recordList)
      } else {
        this.drawHeartChart()
        this.drawTempChart()
      }
      setTimeout(() => {
        this.$store.commit('jlsSignInfo', this.helmetInfo)
      }, 1000)
    },
    // 心率图表
    drawHeartChart(data) {
      let timeArr = []
      let xlength = ''
      let dataArr = []
      if (data) {
        for (let item of data) {
          dataArr.push(item.heartRate)
          let timestamp = item.timestamp
          let stamp = timestamp.split('T')[1].slice(0, -8)
          timeArr.push(stamp)

          // timeArr.push(item.timestamp)
        }
        this.helmetInfo.currenTime = data[0].timestamp.split('T')[0]
        timeArr.reverse()
        dataArr.reverse()
        xlength = parseInt(timeArr.length / 2 - 1)
      }
      try {
        this.$refs.infoWindow.observer.disconnect()
      } catch {
        console.log('')
      }
      let heartChartId = document.getElementById('heartChart')
      if (heartChartId) {
        var myChart = this.$echarts.init(heartChartId)
        // 绘制图表
        myChart.setOption(HeartChartOption(timeArr, xlength, dataArr))
      }
    },
    // 体温图表
    drawTempChart(data) {
      let dataArr = []
      let timeArr = []
      let xlength = ''
      if (data) {
        for (let item of data) {
          // 显示体温
          // dataArr.push(item.bodyTemperature)
          // 显示血氧
          dataArr.push(item.bloodOxygen)
          let timestamp = item.timestamp
          let stamp = timestamp.split('T')[1].slice(0, -8)
          timeArr.push(stamp)
        }
        this.helmetInfo.tempCurrenTime = data[0].timestamp.split('T')[0]
        timeArr.reverse()
        dataArr.reverse()
        xlength = parseInt(timeArr.length / 2 - 1)
      }
      let myChart = this.$echarts.init(document.getElementById('tempChart'))
      // 绘制图表
      myChart.setOption(TempChartOption(timeArr, xlength, dataArr))
    },
    triggerwarn() {
      this.normalPan = !this.normalPan
      if (this.normalPan) {
        this.searchPollInfo(this.jlsHelmet.specType, this.jlsHelmet)
      }
      // this.$refs.infoWindow.observer.disconnect()
    },
    // 弹窗切换告警面板数据
    _findMsgByDeviceName() {
      let findDeviceNamesParams = {
        deviceName: this.deviceName,
      }
      findMsgByDeviceName(findDeviceNamesParams).then(res => {
        if (res.state === 0) {
          if (res.data.length > 0) {
            this.hasWarn = true
            this.tableData = res.data
          } else {
            this.hasWarn = false
            this.tableData = []
          }
        }
      })
    },
    refreshInfoWindow() {
      this.searchPollInfo(this.jlsHelmet.specType, this.jlsHelmet)
    },
    changeJlsTrailVisible() {
      this.$emit('update:JlsTrailVisible', !this.JlsTrailVisible)
      this.$store.commit('jlsTrackList', true)
    },
    // 获取告警类型
    _findAlertType() {
      findAlertType().then(res => {
        this.alertTypeList = res.data
      })
    },
    fileData(row) {
      for (let item of this.alertTypeList) {
        if (row.alertType === item.alertCode) {
          return this.$t(item.alertName)
        }
      }
    },
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.normalContent
  .titleblock
    height 27px
    padding-left 15px
    padding-top 10px
    font-weight bold
    display flex
  .titleblock_warn
    height 27px
    padding-left 15px
    padding-top 10px
    font-weight bold
    display flex
    .warn_icon
      width 17px
      height 17px
      cursor pointer
      display inline-block
      margin-top: 2px
      margin-left: 6px
      bg-image('~@/icon/warn_change.png')
    .warn_icon_m
      width 17px
      height 17px
      cursor pointer
      display inline-block
      margin-top: 2px
      margin-left: 6px
      bg-image('~@/icon/warn_change_m.png')
  .title_normal
    background #EFF1F4
    height 27px
    padding-left 15px
    padding-top 10px
    color #0E65DD !important
    font-weight bold
  .close
    width 16px
    height 16px
    bg-image('~@/icon/monitor/close.png')
    position: absolute;
    right: 10px;
    cursor pointer
  .inforMain
    color #222222
    padding 0 15px
    .inforMainTitle
      padding 5px 10px
    .gpsInfo
      padding 8px 0px
      .trailBtn
        cursor pointer
        font-weight: bold
        display flex
        align-items center
        justify-content center
        float right
        padding 1px 3px
    .deviceInfo
      display flex
      justify-content space-around
      border-top 1px solid #eff1f4
      .func_block
        display flex
        margin-top 4px
        margin-bottom 4px
        .iconBlock
          width 14px
          height 14px
          margin-right 7px
          background-size 100%
        .icon1
          bg-image('~@/icon/rate.png')
        .icon1_m
          bg-image('~@/icon/rate_m.png')
        .icon2
          bg-image('~@/icon/temp.png')
        .icon2_m
          bg-image('~@/icon/temp_m.png')
        .icon3
          bg-image('~@/icon/blood.png')
        .icon3_m
          bg-image('~@/icon/blood_m.png')
        .icon4
          bg-image('~@/icon/signal.png')
        .icon4_m
          bg-image('~@/icon/signal_m.png')
        .icon5
          bg-image('~@/icon/power.png')
        .icon5_m
          bg-image('~@/icon/power_m.png')
        .icon6
          bg-image('~@/icon/height.png')
        .icon6_m
          bg-image('~@/icon/height_m.png')
        .iconInfo
          display flex
          flex-direction column
          position relative
          .description
            font-size 12px
            line-height 12px
            font-weight 500
            margin-bottom 7px
          .description_value
            font-size 12px
            font-weight bold
          #heartChart
            left -8px
            top -8px
            position relative
          #tempChart
            left -8px
            top -8px
            position relative
          .heart-data
            font-size 12px
            position absolute
            bottom -3%
            left 20%
    .deviceIcon
      display flex
      justify-content space-around
      // margin-top 8px
      border-top 1px solid #EFF1F4
      .status_block
        transform none !important
        display flex
        flex-direction column
        align-items center
        margin-top 10px
        .status_des
          margin-top 4px
        .status_icon1
          width 32px
          height 32px
          bg-image('~@/icon/sleep_off.png')
        .status_icon1_on
          width 32px
          height 32px
          bg-image('~@/icon/sleep_on.png')
        .status_icon2
          width 32px
          height 32px
          bg-image('~@/icon/helmet_status_off.png')
        .status_icon2_on
          width 32px
          height 32px
          bg-image('~@/icon/helmet_status_on.png')
        .status_icon3
          width 32px
          height 32px
          bg-image('~@/icon/charge_off.png')
        .status_icon3_on
          width 32px
          height 32px
          bg-image('~@/icon/charge_on.png')
.isOfflineMapClass
  position: absolute;
  top: 20;
  top: 200px;
  left: 400px;
  width 500px;
  border: 1px solid #D4D4D4;
.isOfflineMapWarnClass
  position: absolute;
  top: 20;
  top: 200px;
  left: 400px;
  width 500px;
  height 350px
  overflow: hidden;
  border: 1px solid #D4D4D4;
.warnContent
  .titleblock_warn
    height 27px
    padding-left 15px
    padding-top 10px
    font-weight bold
    display flex
    .close
      width 16px
      height 16px
      bg-image('~@/icon/monitor/close.png')
      position: absolute;
      right: 10px;
      cursor pointer
    .warn_icon
      width 17px
      height 17px
      cursor pointer
      display inline-block
      margin-top: 2px
      margin-left: 6px
      bg-image('~@/icon/warn_change.png')
    .warn_icon_m
      width 17px
      height 17px
      cursor pointer
      display inline-block
      margin-top: 2px
      margin-left: 6px
      bg-image('~@/icon/warn_change_m.png')
  .title
    background #FFE8E8
    height 27px
    font-weight bold
  .DealClass
    color #0E65DD
    cursor pointer
    display inline-block
    width 24px
    height 24px
    bg-image('~@/icon/deal.png')
    background-size 100% 100%
    -moz-background-size 100% 100%
  .unDealClass
    color #0E65DD
    cursor pointer
    display inline-block
    width 24px
    height 24px
    bg-image('~@/icon/unDeal.png')
    background-size 100% 100%
    -moz-background-size 100% 100%
.warn_icon
  width 17px
  height 17px
  cursor pointer
  display inline-block
  margin-top: 2px
  margin-left: 6px
  bg-image('~@/icon/warn_change.png')
.warn_icon_m
  width 17px
  height 17px
  cursor pointer
  display inline-block
  margin-top: 2px
  margin-left: 6px
  bg-image('~@/icon/warn_change_m.png')
.trail_icon
  width 8px
  height 8px
  display inline-block
  margin-left: 2px
  bg-image('~@/icon/monitor/arrow.png')
.trail_icon_m
  width 8px
  height 8px
  display inline-block
  margin-left: 2px
  bg-image('~@/icon/monitor/arrow_m.png')
.fresh_icon
  width 17px
  height 17px
  cursor pointer
  display inline-block
  position: absolute;
  right: 34px;
  bg-image('~@/icon/refresh.png')
.fresh_icon_warn
  width 17px
  height 17px
  cursor pointer
  display inline-block
  position: absolute;
  right: 34px;
  bg-image('~@/icon/refresh_warn.png')
.fresh_icon_warn_m
  width 17px
  height 17px
  cursor pointer
  display inline-block
  position: absolute;
  right: 34px;
  bg-image('~@/icon/refresh_warn_m.png')
>>>.el-table
  height 300px!important
  min-height: 300px!important;/*no*/
  border none!important
</style>
